// eslint-disable-next-line no-unused-vars
import { FormGeneratorConfig } from '../../../utils/formGenerator'
import { FbSliderFormElement } from '../../../utils/formElements'

export const EfficiencyCalcFormConfig: FormGeneratorConfig = {
    horizontal: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Horizontal weight factor',
            marks: true,
            showValueLabel: 'on',
            key: 'horizontal_char_slider',
            step: 0.1,
            min: 0,
            max: 1,
        },
    },
    verticalUp: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Vertical down weight factor',
            marks: true,
            showValueLabel: 'on',
            key: 'vup_char_slider',
            step: 0.1,
            min: 0,
            max: 1,
        },
    },
    verticalDown: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Vertical up weight factor',
            marks: true,
            showValueLabel: 'on',
            key: 'vdown_char_slider',
            step: 0.1,
            min: 0,
            max: 1,
        },
    }
}
